import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Logo } from "@/components/Brand";
import { useLocalAuth } from "@/components/auth/LocalAuth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API, errMsg } from "@/lib/api";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex w-[44%] bg-[#0F1F45] relative grain flex-col justify-between p-12 text-white">
        <Link to="/" className="flex items-center gap-3" data-testid="auth-home-link">
          <div className="bg-white rounded-2xl p-1"><Logo className="h-12 w-12" /></div>
          <span className="font-display text-2xl font-extrabold">Gazi <span className="text-[#FF6B0A]">Sepet</span></span>
        </Link>
        <div>
          <h1 className="text-4xl xl:text-5xl font-extrabold leading-tight">Siparişler, masalar ve kuryeler <span className="text-[#FF6B0A]">tek panelde.</span></h1>
          <p className="mt-5 text-white/70 max-w-md">Yemeksepeti, Trendyol Go Yemek ve Migros Yemek siparişlerinizi, QR menünüzü ve kasanızı tek ekrandan yönetin.</p>
        </div>
        <p className="text-sm text-white/50">Yıllık 6.000 TL — tüm modüller dahil.</p>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center p-6 bg-slate-50">
        <Link to="/" className="lg:hidden mb-6 flex items-center gap-2"><Logo className="h-14 w-14" /></Link>
        {children}
      </div>
    </div>
  );
}

function LocalForm({ mode }) {
  const navigate = useNavigate();
  const { login } = useLocalAuth();
  const [f, setF] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (forgot) {
        await axios.post(`${API}/auth/forgot-password`, { email: f.email });
        toast.success("Sıfırlama bağlantısı oluşturuldu (sunucu kayıtlarına yazıldı)");
        setForgot(false);
      } else {
        const { data } = await axios.post(`${API}/auth/${mode}`, f);
        login(data);
        navigate("/panel");
      }
    } catch (err) {
      toast.error(errMsg(err));
    } finally { setBusy(false); }
  };

  if (forgot)
    return (
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-[#0F1F45]/10 bg-white p-8 shadow-xl space-y-4" data-testid="forgot-form">
        <h2 className="font-display text-xl font-bold text-[#0F1F45]">Şifremi Unuttum</h2>
        <div><Label>E-posta</Label><Input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="forgot-email-input" /></div>
        <Button disabled={busy} className="w-full rounded-full bg-[#FF6B0A] hover:bg-[#E55A00]" data-testid="forgot-submit-btn">Bağlantı Oluştur</Button>
        <button type="button" onClick={() => setForgot(false)} className="text-sm font-semibold text-[#FF6B0A] w-full text-center" data-testid="forgot-back-btn">← Girişe dön</button>
      </form>
    );

  return (
    <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-[#0F1F45]/10 bg-white p-8 shadow-xl space-y-4" data-testid={`${mode}-form`}>
      <h2 className="font-display text-xl font-bold text-[#0F1F45]">{mode === "login" ? "Gazi Sepet'e giriş yapın" : "Gazi Sepet hesabı oluşturun"}</h2>
      {mode === "register" && (
        <div><Label>Ad Soyad / İşletme</Label><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="register-name-input" /></div>
      )}
      <div><Label>E-posta</Label><Input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid={`${mode}-email-input`} /></div>
      <div><Label>Şifre</Label><Input type="password" required minLength={6} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid={`${mode}-password-input`} /></div>
      <Button disabled={busy} className="w-full rounded-full bg-[#FF6B0A] hover:bg-[#E55A00]" data-testid={`${mode}-submit-btn`}>
        {busy ? "Lütfen bekleyin..." : mode === "login" ? "Giriş Yap" : "Kayıt Ol"}
      </Button>
      <div className="flex justify-between text-sm">
        {mode === "login" ? (
          <>
            <button type="button" onClick={() => setForgot(true)} className="text-slate-500 hover:text-[#FF6B0A]" data-testid="login-forgot-link">Şifremi unuttum</button>
            <Link to="/sign-up" className="font-semibold text-[#FF6B0A]" data-testid="login-to-register-link">Kayıt ol</Link>
          </>
        ) : (
          <Link to="/sign-in" className="font-semibold text-[#FF6B0A] ml-auto" data-testid="register-to-login-link">Zaten hesabım var</Link>
        )}
      </div>
    </form>
  );
}

// Kullanıcı e-posta+şifre girişi istedi: Clerk anahtarları sonradan eklense bile yerel form kullanılır
// (admin hesabı yerel veritabanında).
export const SignInPage = () => <Shell><LocalForm mode="login" /></Shell>;
export const SignUpPage = () => <Shell><LocalForm mode="register" /></Shell>;
